import { Component, OnInit } from '@angular/core';

import { ModalService } from 'src/app/shared/modules/modal';
import { FlowChartBaseComponent } from '../flow-chart-base/flow-chart-base.component';
import { NumberFormatService, SessionService } from 'src/app/shared/services';
import { TransactionFlowModalPayload } from 'src/app/shared/models';
import { TransactionFlowChartConstants } from 'src/app/shared/constants';

@Component({
  selector: 'flow-chart-modal',
  templateUrl: './flow-chart-modal.component.html',
})
export class FlowChartModalComponent extends FlowChartBaseComponent implements OnInit {
  data: TransactionFlowModalPayload;
  isModal = true;
  linkLineStroke = TransactionFlowChartConstants.MODAL_LINK_LINE_STROKE;
  elementSelector = TransactionFlowChartConstants.MODAL_ELEMENT_SELECTOR;
  markerRef = TransactionFlowChartConstants.MODAL_MARKER_REF;

  constructor(
    protected modalService: ModalService,
    protected numberFormatService: NumberFormatService,
    protected sessionService: SessionService
  ) {
    super(modalService, numberFormatService, sessionService);
  }

  ngOnInit(): void {
    this.items = this.data.items;
    this.doItems();
    this.calculate();
    this.initiate();
  }

  close(): void {
    this.modalService.closeModal(true);
  }

  setWidthAndHeight(): void {
    this.elementWidth = TransactionFlowChartConstants.SVG_WIDTH;
    this.elementHeight = TransactionFlowChartConstants.MODAL_SVG_HEIGHT;
  }
}
